import { render, staticRenderFns } from "./widgetImage.vue?vue&type=template&id=48087186&scoped=true"
import script from "./widgetImage.vue?vue&type=script&lang=js"
export * from "./widgetImage.vue?vue&type=script&lang=js"
import style0 from "./widgetImage.vue?vue&type=style&index=0&id=48087186&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48087186",
  null
  
)

export default component.exports